module.exports = __webpack_public_path__ + "static/5.4_ancient_egypt-0a81d9a6023632a2e049fe07215e0e43.pdf";